import React, { useEffect, useState } from "react";
import { PageHeaderWrapper, PageLoading } from "@ant-design/pro-layout";
import { Alert, Button, Card } from "antd";
import { connect } from "dva";
import { DealerExchangeType, ShipmentStatus } from "@/utils/enum";
import { getGuidFirst8, getUrlParams } from "@/utils/utils";
import CantDispatchAlert from "@/components/CantDispatchAlert";
import DealerExchangeAlert from "@/components/DealerExchangeAlert";
import DispatchStepsModal from "@/components/DispatchStepsModal";
import ShipmentTags from "@/components/ShipmentTags";
import VehiclesList from "@/components/VehiclesList";
import { DealerDetails } from "./components/DealerDetails";
import { LocationDetails } from "./components/LocationDetails";
import TransporterDetails from "./components/TransporterDetails";

const TransporterShipmentView = ({ transporterShipmentView, loading, configPerm, dispatch }) => {
  const [dispatchStepsModalVisible, setDispatchStepsModalVisible] = useState(false);

  useEffect(() => {
    const shipmentId = getUrlParams("shipmentId");
    dispatch({
      type: "transporterShipmentView/fetchSingleShipment",
      payload: { shipmentId },
    });
  }, [dispatch]);

  const refreshData = () => {
    const shipmentId = getUrlParams("shipmentId");
    dispatch({
      type: "transporterShipmentView/fetchSingleShipment",
      payload: { shipmentId },
    });
  };

  const shipmentData = transporterShipmentView.data;

  if (typeof loading === "undefined" || loading) {
    return <PageLoading />;
  }

  const isChildWithUndeliveredParent =
    shipmentData?.parentShipmentId &&
    shipmentData?.parentShipmentStatus !== ShipmentStatus.Posted &&
    shipmentData?.dealerExchangeType === DealerExchangeType.Ordered;

  const isAssignButtonVisible =
    configPerm["CoreService.AvailableLoads.Accept"] && shipmentData?.status === ShipmentStatus.Posted;

  return (
    <PageHeaderWrapper
      onBack={() => window.history.back()}
      title={`Shipment Details: ${getGuidFirst8(shipmentData?.id)}`}
      tags={<ShipmentTags bold shipment={shipmentData} hideTrailerTypeOnOpen={false} />}
    >
      {!isAssignButtonVisible && <CantDispatchAlert style={{ marginLeft: 20, marginBottom: 16 }} />}

      <Card bordered={false}>
        {shipmentData?.childShipmentId && (
          <DealerExchangeAlert
            relativeUrl="/loads/shipments/view"
            shipmentId={shipmentData.childShipmentId}
            exchangeType={shipmentData.dealerExchangeType}
            isRequired={shipmentData.isExchangeRequired}
            style={{ marginLeft: 20, marginBottom: 16 }}
          />
        )}

        {shipmentData?.parentShipmentId && (
          <DealerExchangeAlert
            isChild
            relativeUrl="/loads/shipments/view"
            shipmentId={shipmentData.parentShipmentId}
            exchangeType={shipmentData.dealerExchangeType}
            isRequired={shipmentData.isExchangeRequired}
            style={{ marginLeft: 20, marginBottom: 16 }}
          />
        )}

        {/* Dealer Details */}
        {shipmentData?.status >= ShipmentStatus.Assigned && <DealerDetails dealer={shipmentData?.dealer} />}

        {/* Transport Details */}
        <TransporterDetails
          shipmentStatus={shipmentData?.status}
          dropOffAddress={shipmentData?.dropOffAddress}
          pickupAddress={shipmentData?.pickupAddress}
        />

        {/* Vehicles Table */}
        {shipmentData?.vehicles && (
          <VehiclesList
            vehicles={shipmentData.vehicles ?? []}
            priceExtractor={item => item?.quote?.transporterPrice}
            shipmentData={shipmentData}
          />
        )}
        {/* Location Details */}
        <LocationDetails
          shipmentId={shipmentData?.id}
          dropOffAddress={shipmentData?.dropOffAddress}
          pickupAddress={shipmentData?.pickupAddress}
          distance={shipmentData?.distance}
        />

        {isChildWithUndeliveredParent && (
          <Alert
            banner
            type="info"
            message="First leg of exchange must be delivered before this leg can be dispatched."
            style={{ marginBottom: 16 }}
          />
        )}
        {isAssignButtonVisible && (
          <Button
            type="primary"
            onClick={() => setDispatchStepsModalVisible(true)}
            disabled={isChildWithUndeliveredParent}
          >
            Accept Shipment
          </Button>
        )}
      </Card>

      <DispatchStepsModal
        visible={dispatchStepsModalVisible}
        setVisible={newState => setDispatchStepsModalVisible(newState)}
        selectedShipments={shipmentData ? [shipmentData] : []}
        refreshParentTable={() => refreshData()}
      />
    </PageHeaderWrapper>
  );
};

export default connect(({ transporterShipmentView, loading, configs }) => ({
  transporterShipmentView,
  loading: loading.effects["transporterShipmentView/fetchSingleShipment"],
  configPerm: configs.configPerm,
}))(TransporterShipmentView);
